import { Injectable, inject } from '@angular/core';

import { UserGroupAclStoreActions, UserGroupAclStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GroupsPermissionResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(UserGroupAclStoreSelectors.selectUserGroupAclByResource('Default-Group')).pipe(
      tap((y) => {
        if (y === undefined) {
          this.store.dispatch(
            UserGroupAclStoreActions.SettingPermissionsResolverActions.userGroupAclRequested({
              resourceId: 'Default-Group',
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
